import { GatewaysApiFactory, V1Gateway, V1GatewayStatus } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { Gateway, GatewayDetails, GatewayStatus } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'
import { HashUtil } from "@/utils/hash";

function convertGatewayStatus(rawGatewayStatus?: V1GatewayStatus): GatewayStatus {
  switch (rawGatewayStatus) {
    case V1GatewayStatus.UNKNOWNGATEWAYSTATUS:
      return GatewayStatus.UNKNOWNGATEWAYSTATUS
    case V1GatewayStatus.UNINITIALIZED:
      return GatewayStatus.UNINITIALIZED
    case V1GatewayStatus.RUNNING:
      return GatewayStatus.RUNNING
    case V1GatewayStatus.SUSPENDED:
      return GatewayStatus.SUSPENDED
    default:
      return GatewayStatus.UNKNOWNGATEWAYSTATUS
  }
}

function createGateways(rawGateways?: V1Gateway[]): Gateway[] {
  if (!rawGateways) return [] as Gateway[]

  const gatewayHashUtil = new HashUtil("gateway");

  return rawGateways.map((g: V1Gateway): Gateway => {
    return new Gateway({
      id: g.id,
      databaseId: g.id !== undefined ? gatewayHashUtil.idFromHash(g.id) : undefined,
      mac: g.mac,
      companyId: g.companyId,
      details: new GatewayDetails({
        status: convertGatewayStatus(g.details ? g.details.status : undefined),
        statusUpdatedTime: g.details ? g.details.statusUpdatedTime : undefined,
      })
    })
  })
}

export const NewGatewaysApiFunc = () => {
  const webAdapter = GatewaysApiFactory(undefined, api.defaults.baseURL, api)

  return {
    adminUnassignGateway: async (companyId: string, gatewayId: string): Promise<ApiResponse<void>> => {
      let err

      try {
        await webAdapter.adminDeleteGateway(companyId, gatewayId)
      } catch (e) {
        err = e
      }

      return {
        data: undefined,
        err
      }
    },

    adminGetGateway: async (companyId: string, gatewayId: string): Promise<ApiResponse<Gateway | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.adminGetGateway(companyId, gatewayId)
        data = createGateways([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    },

    /**
     * 会社管理者向けのゲートウェイ一覧取得API。
     */
    listGateways: async (companyId: string, filter?: string, page?: number, isInstalled?: boolean): Promise<ApiResponse<ListResponse<Gateway>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listGateways(companyId, filter, page, isInstalled)
        // Case for when
        if (res.data === null) {
          data = [] as Gateway[]
          currentPage = 0;
          totalPage = 0;
        } else {
          data = createGateways(res.data.gateways)
          currentPage = res.data.currentPage
          totalPage = res.data.totalPage
        }
      } catch (e) {
        data = [] as Gateway[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    }
  }
}